module.exports = __webpack_public_path__ + "static/media/java.ad887623.jpg";